module.exports = __webpack_public_path__ + "img/business.12c52a63.svg";